import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./Badge.scss";
import { cleanJoin } from "../../utils/stringUtil";

function Badge({
  size = 2,
  icon,
  iconBulmaColor = "black",
  iconSize = 2,
  backgroundBulmaColor = "danger",
  textBulmaColor = "white",
  children,
  className,
  value,
  ...rest
}) {
  return (
    <span {...rest} className={cleanJoin("badge", className)}>
      {children ? (
        <span>{children}</span>
      ) : icon ? (
        <FontAwesomeIcon
          size={`${iconSize}x`}
          className={`has-text-${iconBulmaColor}`}
          icon={icon}
        />
      ) : (
        <></>
      )}
      <span
        className={cleanJoin(
          "tag",
          `is-bv${size}`,
          `has-background-${backgroundBulmaColor}`,
          `has-text-${textBulmaColor}`,
          "is-rounded"
        )}
      >
        {value}
      </span>
    </span>
  );
}

export default Badge;
